import axiosInstance from '../axiosConfigCMS';

export default {
  async getItems() {
    const response = await axiosInstance.get('/cross-sale-items');
    return response.data;
  },
};
